
import { setLoginStats } from "../Actions";

const initialState = {
   Login : {}
} 

function  userReducer(state =  initialState , action) {
  

  switch(action.type){
    case setLoginStats:
   
      var new_stats = action.payload
    
      let state1={ ...state , Login: new_stats}
     
      return { ...state , Login: new_stats};

    default:    
        return state
  }  
}

export default userReducer;